<template>
	<UserRegistrationLayout class="forgot-password-page">
		<v-form
			v-model="isFormValid"
			ref="forgotPasswordForm"
			@submit.prevent="sendForgot"
			class="user-input-box"
			v-if="!submittedSuccessfully"
		>
			<div class="slot-title">Forgot your password?</div>
			<div class="right-side-description">We’ll help you reset it</div>

			<SignupTextField
				label="Email"
				iconName="email"
				:rules="emailRules"
				v-model="userEmail"
				type="email"
				autofocus
				single-line
				placeholder="mail@company.com"
			/>

			<AnemicButton class="reset-button" :loading="submittingForm" type="submit">Reset password</AnemicButton>

			<div class="bottom-section">
				<a @click="navigateTo({ name: 'Login' })" class="link-style subtle">Back</a>
			</div>
		</v-form>
		<div v-else>
			<EnvelopeSVG />
			<div class="slot-title">Check your inbox</div>
			<div class="right-side-description">If the email you entered is associated with an account, you should receive a reset link</div>
			<div class="bottom-section">
				<div>Remember your password? <a @click="navigateTo({ name: 'Login' })" class="primary-link-style ml-1">Log in</a></div>
				<div>Don’t have an account? <a @click="navigateTo({ name: 'Signup' })" class="primary-link-style ml-1">Sign up</a></div>
			</div>
		</div>
	</UserRegistrationLayout>
</template>

<script>
import { mapActions } from 'vuex';

import UserRegistrationLayout from './userRegistration/UserRegistrationLayout';
import SignupTextField from './userRegistration/components/SignupTextField';

import UserRegistrationService from './userRegistration/helpers/UserRegistrationService';
import UserRegistrationMixin from './userRegistration/helpers/UserRegistrationMixin';

import EnvelopeSVG from './userRegistration/assets/EnvelopeSVG';

export default {
	name: 'ForgotPassword',
	components: {
		UserRegistrationLayout,
		EnvelopeSVG,
		SignupTextField,
	},
	props: {
		origEmail: { type: String },
	},
	mixins: [UserRegistrationMixin],
	data: () => ({
		userEmail: '',
		isFormValid: false,
		submittingForm: false,
		submittedSuccessfully: false,
		emailRules: UserRegistrationService.getEmailValidationRules(),
	}),
	methods: {
		...mapActions(['forgotPassword']),
		async sendForgot() {
			this.$refs.forgotPasswordForm.validate();
			if (this.isFormValid) {
				this.submittingForm = true;
				const ret = await this.forgotPassword({ email: this.userEmail });
				this.submittingForm = false;
				if (ret.success) {
					this.submittedSuccessfully = true;
				}
			}
		},
	},
	mounted() {
		if (this.origEmail) {
			this.userEmail = this.origEmail;
		}
	},
};
</script>

<style scoped lang="scss">
.forgot-password-page {
	.bottom-section {
		margin-top: 40px;
	}
}

.reset-button {
	height: 45px;
	width: 300px;
	padding: 0px;
	font-size: 14px !important;
	color: var(--bg-color) !important;
	border: 1px solid var(--bold-border-color);
	background: var(--bold-border-color) !important;
}
.slot-title {
	font-size: 18px;
	font-weight: 600;
	color: var(--primary-font-color);
}
</style>
